import { View, ViewModel } from "binder";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";


export class CustomerAttributeLicenseSelectorViewModel extends SelectorBaseViewModel<CustomerAttribute>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    public getTypeId(): string {
        return "VM-88942B5E-C379-4C92-8F53-B0654A1CA75C"
    }

    protected async loadData(): Promise<CustomerAttribute[]> {
        let result =await ServerConnection.callServer('/Complex/CrmServices/GetAllCustomerLicenses',{})
        return result.AttributeValues.map(x=>{
            let r = new CustomerAttribute(this);
            r.id = x.Id;
            r.title = x.Name;
            return r;
        });
    }

}

export class CustomerAttributeProfessionSelectorViewModel extends SelectorBaseViewModel<CustomerAttribute>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    public getTypeId(): string {
        return "VM-88942B5E-C379-4C92-8F53-B0654A1CA75C"
    }

    protected async loadData(): Promise<CustomerAttribute[]> {
        let result =await ServerConnection.callServer('/Complex/CrmServices/GetAllCustomerProfession',{})
        return result.AttributeValues.map(x=>{
            let r = new CustomerAttribute(this);
            r.id = x.Id;
            r.title = x.Name;
            return r;
        });
    }

}

export class CustomerAttributeWorkingAreaSelectorViewModel extends SelectorBaseViewModel<CustomerAttribute>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    public getTypeId(): string {
        return "VM-88942B5E-C379-4C92-8F53-B0654A1CA75C"
    }

    protected async loadData(): Promise<CustomerAttribute[]> {
        let result =await ServerConnection.callServer('/Complex/CrmServices/GetAllCustomerWorkingArea',{})
        return result.AttributeValues.map(x=>{
            let r = new CustomerAttribute(this);
            r.id = x.Id;
            r.title = x.Name;
            return r;
        });
    }

}

export class CustomerAttribute extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}